import { formatCurrency, formatIndianNumber } from "../../utils/currencyUtils";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";

const CurrencyDisplay = ({ amount, className = "" }) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={`cursor-help ${className}`}>₹{formatIndianNumber(amount)}</span>
        </TooltipTrigger>
        <TooltipContent>
          <p>{formatCurrency(amount)}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default CurrencyDisplay;
